import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsNumber, IsOptional } from "class-validator";

export class QaqcApprovalDto {
    @ApiProperty()
    @IsNotEmpty()
    @IsNumber()
    id: number;

    @ApiProperty()
    @IsNotEmpty()
    testType: 'work_order' | 'lot';

    @ApiProperty()
    @IsNotEmpty()
    analysisType: 'SILKFIBERANALYSIS' | 'SILKFIBERLABANALYSIS';

    @ApiProperty()
    @IsNotEmpty()
    @IsNumber()
    productId: number;

    @IsOptional()
    workOrderNo?: string;

    @IsOptional()
    lotNumber?: string;
}
